import UnitTypeTable from "@/app/app-shared/unit-type/table";

export default function UnitTypeListingPage() {
  return (
    <div className="mt-4">
      <UnitTypeTable />
    </div>
  );
}
